// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[data-inputcheck].fieldError {
  border-width: 2px !important;
  padding: 1px !important;
  border-color: #e00000 !important; /* brightish red color */
}

input[data-inputcheck] {
  padding: 2px !important;
  border-width: 1px !important;
}
`, "",{"version":3,"sources":["webpack://./wwwroot/Views/Shared/css/_HtmlInputChecker.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,gCAAgC,EAAE,wBAAwB;AAC5D;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B","sourcesContent":["input[data-inputcheck].fieldError {\r\n  border-width: 2px !important;\r\n  padding: 1px !important;\r\n  border-color: #e00000 !important; /* brightish red color */\r\n}\r\n\r\ninput[data-inputcheck] {\r\n  padding: 2px !important;\r\n  border-width: 1px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
